module.exports = __webpack_public_path__ + "img/img52.62751fd9.png";